import { InjectedStyledComponent } from '../InjectedStyledComponent';
import List from './List';

export default InjectedStyledComponent(List, 'shared', ['dropdownList']);